import { EntryPage, SignInForm, SignInSSO, useTenant, NavBar as PublicNavBar } from '@emerald-works-nova/auth'
import { Grid } from '@mui/material'
import React from 'react'
import { routes } from '../../routes'
import { useStyles } from './style'

const Login = () => {
  const classes = useStyles()
  const tenant = useTenant()
  return (
    <Grid
      container
      direction='column'
      wrap='nowrap'
    >
      <Grid item style={{ minHeight: 85 }}>
        <PublicNavBar
          captionText="Don't have an account?"
          link={routes.register.path}
          buttonText='Sign up'
        />
      </Grid>
      <Grid item>
        <EntryPage
          title='Sign in'
          subtitle='Enter your registered email address below.'
          showMtLogo
          loginProviders={tenant?.loginProviders}
          content={
            <SignInForm
              redirectRoute={routes.home.path}
              submitBtnText='Get Started'
              sharpbox
              forgotPasswordRoute={routes.forgotPassword.path}
            />
          }
          sso={
            <SignInSSO
              className={classes.sso}
              loginProviders={tenant.loginProviders}
              text='&nbsp;&nbsp;Or'
            />
          }
          application={process.env.REACT_APP_APPLICATION_NAME}
        />
      </Grid>
    </Grid>
  )
}

export default Login
